const translations = {
  PageTitle: "Dataset Viewer",
  FetchError: "Failed to load datasets",
  ObjectDatasetsTab: "Object Datasets",
  DefectDatasetsTab: "Defect Datasets",
  Name: "Name",
  TypeList: "Type List",
  Date: "Date",
  Whitelist: "Approved Projects",
  Blacklist: "Non-Included Projects",
  SyntheticProjects: "Synthetic Projects",
  Sensitive: "Sensitive",
  ModifiedSinceIntegration: "Modified",
  ModifiedSinceIntegrationTooltip:
    "A relevant object type was edited in the annotation tool since this dataset was last built — the dataset may be out of date",
  ShowDeprecated: "Show deprecated",
  SearchPlaceholder: "Search datasets…",
  FilterByType: "Filter by type…",
  HideInaccessible: "Hide datasets with no accessible projects",
  InaccessibleProject: "Project not found — it may be on another domain",
  UnknownProject: (id: number) => `Unknown project #${id}`,
  UnknownObjectType: (id: number) => `Type #${id}`,
  Settings: "Settings",
  ProjectNameDisplay: "Project Name Display",
  DisplayID: "ID",
  DisplayIDAndName: "ID & Name",
  LoadingImages: "Loading…",
  ImageCount: (count: number) => `${count.toLocaleString()} images`,
  ProjectCount: (count: number) => `${count.toLocaleString()} projects`,
  Filter: "Filter",
  SplitFilterLabel: "Train / Test",
  SplitAll: "Both",
  SplitTrain: "Train",
  SplitTest: "Test",
  StatusFilterLabel: "Detections",
  StatusAll: "All",
  StatusHasTp: "Has Positive",
  StatusOnlyFp: "Negatives Only",
  TypeFilterLabel: "Object types",
  ProjectFilterLabel: "Projects",
  FilterByProject: "Filter by project…",
  ImageHasTruePositive: "Has a true positive",
  ImageHasFalsePositive: "Has a false positive",
  ImageHasObjectWithoutDefect: "Has an object without a defect",
  ImageSeenThisSession: "Viewed this session",
  ActiveImageHiddenByFilter: "The current image is hidden by this filter",
  ImageNotFound: "Image not found in dataset",
  FailedToLoadImages: "Failed to load dataset images",
  FailedToLoadDataset: "Failed to load dataset",
  FailedToLoadAnnotations: "Failed to load annotations",
  OpenInAnnotationToolOn: (domainName: string) =>
    `Open in Annotation Tool (${domainName})`,
  TrainImage: "Train image",
  TestImage: "Test image",
  AnnotationToolUnavailable:
    "Project not found in this region — annotation tool unavailable",
  CloseImage: "Close image",
  Unsuperverify: "Downgrade Supervisor-verified",
  UnsuperverifyTooltip:
    "Downgrade Supervisor Approved / Supervisor False Positive detections",
  UnsuperverifyNothingTooltip:
    "No Supervisor Approved or Supervisor False Positive detections to downgrade",
  UnsuperverifyTitle: "Downgrade Supervisor-verified detections?",
  UnsuperverifyBody: (count: number) =>
    `This sets ${count} Supervisor-verified detection${
      count === 1 ? "" : "s"
    } on this image back to its prior status (Supervisor Approved to True Positive, Supervisor False Positive to False Positive) and flags the dataset as modified. This cannot be undone.`,
  UnsuperverifyConfirm: "Downgrade",
  UnsuperverifyCancel: "Cancel",
  UnsuperverifySuccess: (count: number) =>
    `Downgraded ${count} detection${count === 1 ? "" : "s"}`,
  UnsuperverifyError: "Failed to downgrade detections",
  ImageErrorNotFound: "Image does not exist in CDN, perhaps it was deleted?",
  ImageErrorUnauthorized: "You do not have access to this project",
  ImageErrorGeneric: (errorCode: number | string) =>
    `Failed to load image (${errorCode})`,
  Original: "Original",
  Augmented: "Augmented",
  MappedImageHasNoCrops: "This image didn't produce any crops.",
  ImageCropsCouldntBeFound: "Crops couldn't be found for this image.",
  ViewModeList: "List",
  ViewModeAllCrops: "All crops",
  ToggleAllCropsView: "Toggle all-crops view",
  AllCropsLoading: "Loading crops…",
  NoDatasetCropsFound: "No crops found in this dataset.",
  CropCount: (count: number) => `${count.toLocaleString()} crops loaded`,
  GoToCurrentCrop: "Scroll to current image",
  NoCropsForCurrentImage: "The current image has no crops in this dataset.",
};

export default translations;
